import 'uScope/js/extensions/annotations/index';
import 'uScope/js/extensions/auto-pan/index';
import 'uScope/js/extensions/conferencing/index';
// import 'uScope/js/extensions/image-adjust/index'; // Created for ePath Access; not used by eSM; no requirements...
import 'uScope/js/extensions/image-analysis/index'; // TODO: Move to IA?
import 'uScope/js/extensions/image-toolbar';
import 'uScope/js/extensions/image-quality-indicator';
import 'uScope/js/extensions/imagescope-launcher';
import 'uScope/js/extensions/label';
import 'uScope/js/extensions/magnifier';
import 'uScope/js/extensions/manual-sync';
import 'uScope/js/extensions/pdx-support';
import 'uScope/js/extensions/raster-scan';
import 'uScope/js/extensions/rotation-dial';
import 'uScope/js/extensions/scalebar';
import 'uScope/js/extensions/settings-services';
import 'uScope/js/extensions/snapshot';
import 'uScope/js/extensions/thumbnail';
import 'uScope/js/extensions/user-config';
import 'uScope/js/extensions/zoom';

// Disable debugging tools.
// import 'uScope/js/debugging/render-editor';
// import 'uScope/js/debugging/viewport-tools';
// import 'uScope/js/debugging/performance-services';



// WEBPACK FOOTER //
// ./src/lib/uscope-extensions.js